import { AllowedImageAspectRatios } from '#types/generated/graphql-types';

export const NamedToNumericRatio = {
  [AllowedImageAspectRatios.FourByThree]: '4_3',
  [AllowedImageAspectRatios.SixteenBySeven]: '4937_2160',
  [AllowedImageAspectRatios.SixteenByNine]: '16_9',
  [AllowedImageAspectRatios.SixteenByTen]: '16_10',
  [AllowedImageAspectRatios.ThreeByFour]: '3_4',
  [AllowedImageAspectRatios.ThreeByFive]: '3_5',
  [AllowedImageAspectRatios.EightByFive]: '8_5',
  [AllowedImageAspectRatios.OneByOne]: '1_1',
};

export const NumericToNamedRatio = {
  '4_3': [AllowedImageAspectRatios.FourByThree],
  '4937_2160': [AllowedImageAspectRatios.SixteenBySeven],
  '16_9': [AllowedImageAspectRatios.SixteenByNine],
  '16_10': [AllowedImageAspectRatios.SixteenByTen],
  '3_4': [AllowedImageAspectRatios.ThreeByFour],
  '3_5': [AllowedImageAspectRatios.ThreeByFive],
  '8_5': [AllowedImageAspectRatios.EightByFive],
  '1_1': [AllowedImageAspectRatios.OneByOne],
};
